import { ReactComponent as LogoPrevlink } from '../media/logo_Prevlink.svg';
import { ReactComponent as LogoAIRFRANCE } from '../media/logo-airfrance.svg';
// Logo RAVAIL en PNG haute résolution (et non en SVG inline) : html2canvas rastérise mal les SVG
// inline sans dimensions (flou dans les PDF générés) ; un raster haute déf reste net.
import logoRAVAILHorizontal from '../media/logo_RAVAIL_horizontal.png';
import { FileTextOutlined } from '@ant-design/icons';

function CustomDocumentHeader({ serviceId, ...props }) {
  if (serviceId === "PREVLINK" || serviceId === "AMETIF") {
    return (
      <div {...props}>
        <div id="ravail-document-header">
          <div className="logo-adresse">
            <div style={{ marginTop: "2mm", marginBottom: "0", width: "52mm", float: "left" }}>
              <LogoPrevlink style={{ width: "6cm" }} />
            </div>
            <div style={{ color: "#767171", fontFamily: '"Century Gothic",sans-serif', fontSize: "8.0pt", textAlign: "center", width: "52mm", float: "right" }}>
              <span>
                SIÈGE SOCIAL
              </span><br />
              <span>
                80 rue de Clichy
              </span><br />
              <span>
                75009 Paris
              </span><br />
              <span>
                Tél. : 01 49 70 84 84
              </span><br />
              <span>
                www.cmie.fr
              </span>
            </div>
          </div>
          <div className="img-document">
            <FileTextOutlined style={{ color: "white", fontSize: "20mm" }} />
          </div>
        </div>
      </div>);
  }
  else if (serviceId === "AIRFRANCE" || serviceId === "AIR FRANCE" || serviceId === "Air France") {
    return (
      <div {...props}>
        <div id="ravail-document-header">
          <div className="logo-adresse">
            <div style={{ marginTop: "2mm", marginBottom: "0", width: "52mm", float: "left" }}>
              <LogoAIRFRANCE />
            </div>
            <div style={{ color: "#767171", fontFamily: '"Century Gothic",sans-serif', fontSize: "8.0pt", textAlign: "center", width: "52mm", float: "right" }}>
              <span>
                SIÈGE SOCIAL
              </span><br />
              <span>
                45 rue de Paris
              </span><br />
              <span>
                95747 Roissy CDG
              </span><br />
              <span>
                Tél. : 01 41 56 78 00
              </span><br />
              <span>
                www.airfrance.fr
              </span>
            </div>
          </div>
          <div className="img-document">
            <FileTextOutlined style={{ color: "white", fontSize: "20mm" }} />
          </div>
        </div>
      </div>);
  }
  return (
    <div {...props}>
      <div id="ravail-document-header">
        <div className="logo-adresse">
          <div style={{ width: "52mm", float: "left", height: "100%" }}>
            <img src={logoRAVAILHorizontal} alt="RAVAIL" style={{ height: "100%" }} />
          </div>
          <div style={{ color: "#767171", fontFamily: '"Century Gothic",sans-serif', fontSize: "8.0pt", textAlign: "center", width: "52mm", float: "right" }}>
          </div>
        </div>
        <div className="img-document">
          <FileTextOutlined style={{ color: "white", fontSize: "20mm" }} />
        </div>
      </div>
    </div>
  );
}

export default CustomDocumentHeader;